var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHold = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "100%",
    height: "100%",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.627,6.544c0,-1.543 -1.253,-2.796 -2.796,-2.796c-1.543,0 -2.796,1.253 -2.796,2.796l0,19.662c0,1.543 1.253,2.796 2.796,2.796c1.543,0 2.796,-1.253 2.796,-2.796l0,-19.662Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.949,6.544c0,-1.543 -1.252,-2.796 -2.795,-2.796c-1.543,0 -2.795,1.253 -2.795,2.796l0,19.663c0,1.543 1.252,2.795 2.795,2.795c1.543,0 2.795,-1.252 2.795,-2.795l0,-19.663Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hold.cbe4e7697575a07ee94a2fc1ca01cbbf.svg";